var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchievementObjectives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "contenitore",
    width: 70,
    height: 70,
    transform: "translate(285 633)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "raggiungimento_obiettivi",
    "data-name": "raggiungimento obiettivi",
    transform: "translate(-104 -299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppo_di_maschere_29",
    "data-name": "Gruppo di maschere 29",
    transform: "translate(-181 -334)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fondo",
    d: "M3.371,63.393s-5.693-9.719-2.283-18.97S11,37.365,20.12,27.966C31.186,16.55,38.958,15.922,48.828,20.908c5.586,2.821,6.49,14.425,15.379,21.63,8.015,6.5,1.477,17.566-2.73,19.291a20.655,20.655,0,0,1-7.063,1.725S48.09,86.92,29.242,86.119,3.371,63.393,3.371,63.393Z",
    transform: "translate(286.1 616.06)",
    fill: "#dedbdb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "raggiungimento_obiettivi-2",
    "data-name": "raggiungimento obiettivi",
    transform: "translate(3 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3269",
    "data-name": "Raggruppa 3269",
    transform: "translate(283.941 634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1819",
    "data-name": "Tracciato 1819",
    d: "M-.014,0l57.28-3.207L57.083.8-.2,4.01Z",
    transform: "translate(0 34.203) rotate(-30.649)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1820",
    "data-name": "Tracciato 1820",
    d: "M0,0,73.633-3.828l-.2,4.01L-.2,4.01Z",
    transform: "translate(0.731 50.791) rotate(-30.649)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1821",
    "data-name": "Tracciato 1821",
    d: "M0,0,61.681-3.207,61.484.8-.2,4.01Z",
    transform: "translate(13.163 59.203) rotate(-30.649)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3270",
    "data-name": "Raggruppa 3270",
    transform: "translate(287.571 640)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3257",
    "data-name": "Raggruppa 3257",
    transform: "translate(0 1.633)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_200",
    "data-name": "Ellisse 200",
    cx: 24.05,
    cy: 24.05,
    r: 24.05,
    transform: "translate(0 0)",
    fill: "#285f8f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3254",
    "data-name": "Raggruppa 3254",
    transform: "translate(3.078 3.078)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_201",
    "data-name": "Ellisse 201",
    cx: 20.526,
    cy: 20.526,
    r: 20.526,
    transform: "translate(0.446 0.446)",
    fill: "#337ab7",
    stroke: "#fff",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1773",
    "data-name": "Tracciato 1773",
    d: "M766.783,483.634a21.149,21.149,0,0,1-4.48-.482A20.964,20.964,0,1,1,787.231,467.1l-.429-.093.429.093a20.983,20.983,0,0,1-20.448,16.534Zm-.082-41.066a20.092,20.092,0,1,0,19.672,24.347h0a20.088,20.088,0,0,0-15.38-23.884A20.24,20.24,0,0,0,766.7,442.568Z",
    transform: "translate(-745.77 -441.691)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3255",
    "data-name": "Raggruppa 3255",
    transform: "translate(11.093 11.093)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_202",
    "data-name": "Ellisse 202",
    cx: 12.513,
    cy: 12.513,
    r: 12.513,
    transform: "translate(0.443 0.444)",
    fill: "#bfd7ed",
    stroke: "#fff",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1774",
    "data-name": "Tracciato 1774",
    d: "M955.148,663.989a13.061,13.061,0,0,1-2.768-.3,12.886,12.886,0,1,1,2.768.3Zm-.05-25.035a12.11,12.11,0,1,0,2.58.278A12.192,12.192,0,0,0,955.1,638.954Z",
    transform: "translate(-942.166 -638.076)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3256",
    "data-name": "Raggruppa 3256",
    transform: "translate(18.761 18.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1822",
    "data-name": "Tracciato 1822",
    d: "M6,0A6,6,0,1,1,0,6,6,6,0,0,1,6,0Z",
    transform: "translate(-0.56 -0.561)",
    fill: "#03518c",
    stroke: "#fff",
    strokeWidth: 1.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3258",
    "data-name": "Raggruppa 3258",
    transform: "translate(23.86 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1776",
    "data-name": "Tracciato 1776",
    d: "M1423.564,406.77l.5.771-29.185,18.792-.5-.771Z",
    transform: "translate(-1388.692 -403.484)",
    fill: "#db5f00",
    stroke: "#db5f00",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1777",
    "data-name": "Tracciato 1777",
    d: "M1259.162,830.611c.387-.229,3.8,3.853,3.418,4.082l-7.255,1.44c-.24.108-.449-.19-.243-.347Z",
    transform: "translate(-1255.528 -809.776)",
    fill: "#db5f00",
    stroke: "#db5f00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1778",
    "data-name": "Tracciato 1778",
    d: "M1929.01,425.92l3.158,1.02-5.39,3.47a7.008,7.008,0,0,1-5.948.777h0Z",
    transform: "translate(-1893.657 -420.852)",
    fill: "#db5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1779",
    "data-name": "Tracciato 1779",
    d: "M1916.85,329.547l.378-3.3-5.39,3.471a7.008,7.008,0,0,0-3.168,5.093h0Z",
    transform: "translate(-1882.993 -326.25)",
    fill: "#db5f00"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievementObjectives);
export default __webpack_public_path__ + "static/media/achievement_objectives.5d403cd3c113d8eecde947f1a3c703ab.svg";
export { ForwardRef as ReactComponent };